export default function HowItWorks() {
  const steps = [
    { num: '01', title: 'Browse Spreadsheets', desc: 'Explore curated Vigorbuy spreadsheets organized by category, brand, and popularity.' },
    { num: '02', title: 'Compare Products', desc: 'Use side-by-side comparisons to evaluate pricing, sizing, and availability.' },
    { num: '03', title: 'Read QC Guides', desc: 'Follow our detailed quality check guides to verify product authenticity.' },
    { num: '04', title: 'Learn Safe Buying', desc: 'Study our safety practices to protect yourself throughout the buying process.' },
    { num: '05', title: 'Visit Vigorbuy', desc: 'Click through directly to the official store and complete your purchase with confidence.' },
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">Process</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4">
            How It Works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, idx) => (
            <div key={idx} className="relative text-center group">
              <div className="w-14 h-14 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <span className="font-heading text-lg font-bold text-accent-700">{step.num}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">{step.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed max-w-[180px] mx-auto">{step.desc}</p>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-7 -right-3 text-accent-300">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}